/* eslint-disable prefer-destructuring */
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Button, Card, CardActions, CardContent, CardHeader, Divider } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import clsx from 'clsx';
import axios from 'axios';
import Cookies from 'universal-cookie';
import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import { Link, useHistory } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import { DashboardPanelContext } from '../../../../components/context/DashboardContext';
import BSubmitButton from '../../../../components/buttons/SubmitButton';
import BCheckBoxField from '../../../../components/inputs/forms/BCheckBoxField';
import { REQUIRED_STRING } from '../../../../constants/HookForm';
import { Map } from '../../../../components/Map/Map';
import BTextField from '../../../../components/inputs/forms/BTextField';
import {
  setValues,
  onChangeForBComponents,
  onKeyDownHandlerOnlyAcceptEnglishCharacter,
  onKeyDownHandlerOnlyAcceptIntegerEnglish,
  onKeyDownHandlerOnlyAcceptEmailCharacters,
} from '../../../../common/utilities';
import { BSwalShowError } from '../../../../common/BSwal';
import useHistoryForms from '../../../../hooks/useHistoryForms';
import BHistoryNavigator from '../../../../components/BHistoryNavigator';
import useBasicInformationMountedEffect from '../../../../hooks/useBasicInformationMountedEffect';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  customInputFormControl: {
    width: '100%',
  },
  formLabel: {
    fontSize: 16,
    marginBottom: 10,
  },
}));

const cookies = new Cookies();

const initialEmployee = {
  f_name: '',
  l_name: '',
  name: '',
  mobile: null,
  email: '',
  password: null,
  status: true,
  is_admin: false,
  profile_image: null,
  full_address: '',
  latitude: null,
  longitude: null,
};

const EmployeePage = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const { staticContext, ...rest } = props;
  const { globalState } = useContext(DashboardPanelContext);

  const { viewReadOnly } = globalState;

  const [loading, setLoading] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const { errors, handleSubmit, setValue, register } = useForm();
  const [fullAdress, setFullAddress] = useState('');
  const [rerenderMap, setRerenderMap] = useState(0);
  // const [newLocation, setNewLocation] = useState([]);
  const [searchLat, setSearchLat] = useState('');
  const [searchLang, setSearchLang] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const incrementRendererMap = () => setRerenderMap((prev) => prev + 1);
  const handleNewMarkMoved = (point) => point?.lat;
  // && setNewLocation([point.lat, point.lng])
  const {
    fetchData,
    prevHistory,
    nextHistory,
    HistoryId,
    historyIdList,
    historyStep,
    history: fetchedHistory,
    historyInfo,
  } = useHistoryForms({
    location: props.location,
    route: '/employee-management/employees',
  });

  const {
    id,
    item: currentPersonnel,
    setItem: setCurrentPersonnel,
  } = useBasicInformationMountedEffect({
    match: props.match,
    historyIdList,
    fetchItemURL: '/users',
    localStorageKey: 'users',
    initialItem: initialEmployee,
    fetchData,
    historyId: HistoryId,
  });

  const fileSelectedHandlerLoad = async (e) => {
    setProfileImage(null);
    const name = 'https://portal.furniturerepairexpert.com/furniture-repair/public/'.concat(e);
    const imgSrc = `${name}?w=164&h=164&fit=crop&auto=format`;
    // eslint-disable-next-line no-shadow
    setProfileImage({ img: imgSrc });
  };

  useEffect(() => {
    const _order = { ...currentPersonnel };
    _order.full_address = fullAdress;
    _order.latitude = '';
    _order.longitude = '';
    setCurrentPersonnel(_order);
  }, [fullAdress]);

  useEffect(() => {
    if (currentPersonnel.latitude && currentPersonnel.longitude) {
      incrementRendererMap();
    }
  }, [currentPersonnel.latitude, currentPersonnel.longitude]);

  useEffect(() => {
    if (!viewReadOnly) {
      register(
        { name: 'f_name' },
        {
          required: REQUIRED_STRING,
        },
      );
      register(
        { name: 'l_name' },
        {
          required: REQUIRED_STRING,
        },
      );
      register(
        { name: 'email' },
        {
          required: REQUIRED_STRING,
        },
      );
      register(
        { name: 'mobile' },
        {
          required: REQUIRED_STRING,
        },
      );
      register(
        { name: 'private_order_percentage' },
        {
          required: REQUIRED_STRING,
        },
      );
      register(
        { name: 'insurance_order_percentage' },
        {
          required: REQUIRED_STRING,
        },
      );
      register(
        { name: 'full_address' },
        {
          required: REQUIRED_STRING,
        },
      );
    }
  }, []);
  useEffect(() => {
    if (currentPersonnel.data) {
      setCurrentPersonnel(currentPersonnel.data);
    }
    if (currentPersonnel) {
      setValues(setValue, currentPersonnel);
    }
    if (currentPersonnel.id && currentPersonnel.profile_image) {
      fileSelectedHandlerLoad(currentPersonnel.profile_image);
    }
  }, [currentPersonnel]);

  useEffect(() => {
    if (fetchedHistory && historyIdList.length !== 0) {
      setCurrentPersonnel(fetchedHistory);
    }
  }, [fetchedHistory]);

  useEffect(() => {
    if (!viewReadOnly) {
      if (window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1) === 'employee') {
        register(
          { name: 'password' },
          {
            validate: (c) => c?.length >= 8 || 'The password must be at least 8 characters.',
          },
        );
      }
    }
  }, []);

  const onSubmit = () => {
    setLoading(true);
    const personnel = { ...currentPersonnel };
    if (personnel.password > 0 && confirmPassword !== personnel.password) {
      BSwalShowError(['Password does not match']);
      setLoading(false);
      return;
    }
    if (searchLang || searchLat) {
      personnel.latitude = searchLat;
      personnel.longitude = searchLang;
    }
    if (!personnel.latitude || !personnel.longitude) {
      BSwalShowError(['Please select the exact location of the address on the map.']);
      setLoading(false);
      return;
    }
    if (currentPersonnel.status) {
      personnel.status = '1';
    } else {
      personnel.status = '0';
    }
    if (currentPersonnel.is_admin && currentPersonnel.is_admin !== '0') {
      personnel.is_admin = '1';
    } else {
      personnel.is_admin = '0';
    }
    personnel.name = personnel.email;
    axios.defaults.baseURL = `${process.env.REACT_APP_BASE_URL}`;
    const formData = new FormData();
    for (let i = 0; i < Object.keys(personnel).length; i++) {
      formData.append(Object.keys(personnel)[i], Object.values(personnel)[i]);
    }
    axios({
      method: 'post',
      url: id ? 'users/'.concat(id).concat('?_method=PUT') : 'users',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${cookies.get('userToken')}`,
      },
    })
      .then((res) => {
        if (res.data.data) {
          history.push('/employee-management/employees');
        }
        if (res?.data?.error?.email) {
          BSwalShowError(res?.data?.error?.email);
        }
      })
      .catch((err) => BSwalShowError(err?.data?.messages))
      .finally(() => setLoading(false));
  };

  const onChange = (e) => {
    onChangeForBComponents(e, setValue, currentPersonnel, setCurrentPersonnel);
  };

  const fileSelectedHandler = async (e) => {
    const _currentPersonnel = currentPersonnel;
    _currentPersonnel.profile_image = null;
    setProfileImage(null);
    const file = e.target.files[0];
    // eslint-disable-next-line no-shadow
    // const formData = new FormData();
    // formData.append('profile_image', file);
    // console.log('ffff', formData);
    _currentPersonnel.profile_image = file;
    setCurrentPersonnel(_currentPersonnel);
    const reader = new FileReader();
    // const url = reader.readAsDataURL(file);
    reader.onloadend = () => {
      // eslint-disable-next-line no-shadow
      setProfileImage({ img: reader.result });
    };
  };
  const setAddress = (address) => {
    setFullAddress(address?.geocode?.name);
    setSearchLat(address?.geocode?.center?.lat);
    setSearchLang(address?.geocode?.center?.lng);
  };
  return (
    <div className={classes.root} style={{ margin: 10 }}>
      {currentPersonnel && (
        <Card {...rest} className={clsx(classes.root)}>
          <Button
            id='backToListIcon'
            component={Link}
            to={{
              pathname: '/employee-management/employees',
            }}
            color='secondary'
            variant='outlined'
            style={{ float: 'right', marginTop: '10px', marginRight: '10px' }}
          >
            <ArrowBackIcon />
          </Button>
          <form className='formContainer' onSubmit={handleSubmit(onSubmit)}>
            <CardHeader title='Employee Information' />
            <Divider />
            <CardContent>
              <br />
              {historyInfo}
              <Grid container spacing={3}>
                <BTextField
                  label='First Name'
                  name='f_name'
                  value={currentPersonnel?.f_name}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  onKeyDown={onKeyDownHandlerOnlyAcceptEnglishCharacter}
                  error={errors.f_name}
                  required
                />

                <BTextField
                  label='Last Name'
                  name='l_name'
                  value={currentPersonnel?.l_name}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  onKeyDown={onKeyDownHandlerOnlyAcceptEnglishCharacter}
                  error={errors.l_name}
                  required
                />

                <BTextField
                  label='Mobile'
                  sm={4}
                  name='mobile'
                  value={currentPersonnel?.mobile}
                  onChange={onChange}
                  error={errors.mobile}
                  onKeyDown={onKeyDownHandlerOnlyAcceptIntegerEnglish}
                  readOnly={viewReadOnly}
                  required
                />

                <BTextField
                  label='Email'
                  name='email'
                  required
                  value={currentPersonnel?.email}
                  error={errors.email}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  onKeyDown={onKeyDownHandlerOnlyAcceptEmailCharacters}
                />

                <BTextField
                  type='password'
                  name='password'
                  label='Password'
                  value={currentPersonnel?.password}
                  onChange={onChange}
                  required={!currentPersonnel.id}
                  error={errors.password}
                />
                <BTextField
                  type='password'
                  name='confirm_password'
                  label='Confirm Password'
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.currentTarget.value)}
                  required={!currentPersonnel.id}
                />
                <BTextField
                  label='Private Order Percentage'
                  sm={4}
                  name='private_order_percentage'
                  value={currentPersonnel?.private_order_percentage}
                  onChange={onChange}
                  error={errors.private_order_percentage}
                  onKeyDown={onKeyDownHandlerOnlyAcceptIntegerEnglish}
                  readOnly={viewReadOnly}
                  required
                />
                <BTextField
                  label='Insurance Order Percentage'
                  sm={4}
                  name='insurance_order_percentage'
                  value={currentPersonnel?.insurance_order_percentage}
                  onChange={onChange}
                  error={errors.insurance_order_percentage}
                  onKeyDown={onKeyDownHandlerOnlyAcceptIntegerEnglish}
                  readOnly={viewReadOnly}
                  required
                />
                <Grid container spacing={1}>
                  <Grid item sm={12} style={{ marginTop: '20px', height: '300px' }}>
                    <Map
                      key={rerenderMap}
                      center={
                        currentPersonnel.latitude ? [currentPersonnel.latitude, currentPersonnel.longitude] : null
                      }
                      marker={{
                        position: [currentPersonnel.latitude, currentPersonnel.longitude],
                        popup: '',
                      }}
                      onNewMarkerMoved={handleNewMarkMoved}
                      setAddress={setAddress}
                      geoCoder
                    />
                  </Grid>
                </Grid>
                <BTextField
                  sm={12}
                  xs={12}
                  label='Full Address'
                  required
                  name='full_address'
                  value={currentPersonnel?.full_address}
                  error={errors?.full_address}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />

                <Grid item xs={12} sm={12}>
                  <CardHeader title='Profile Image' style={{ padding: '0' }} />
                  <input
                    type='file'
                    onChange={fileSelectedHandler}
                    style={{ marginBottom: '15px', marginTop: '15px' }}
                  />
                  <Avatar alt='Remy Sharp' src={profileImage?.img} style={{ width: '100px', height: '100px' }} />
                </Grid>

                <BCheckBoxField
                  sm={12}
                  name='is_admin'
                  label='Is Admin'
                  value={Number(currentPersonnel?.is_admin)}
                  error={errors.is_admin}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />

                <BCheckBoxField
                  sm={12}
                  name='status'
                  label='Enabled Status'
                  value={Number(currentPersonnel?.status)}
                  error={errors.status}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />
              </Grid>
            </CardContent>
            <Divider />
            <CardActions>
              <Grid item xs={12} sm={6}>
                {!viewReadOnly && <BSubmitButton id='submitEmployee' label='Save Employee' loading={loading} />}
              </Grid>
              <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  id='backToList'
                  component={Link}
                  to={{
                    pathname: '/employee-management/employees',
                  }}
                  color='secondary'
                  variant='outlined'
                >
                  Back to employee list
                </Button>
              </Grid>
            </CardActions>
          </form>
          <BHistoryNavigator
            historyStep={historyStep}
            historyIdList={historyIdList}
            prevHistory={prevHistory}
            nextHistory={nextHistory}
          />
        </Card>
      )}
    </div>
  );
};

EmployeePage.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
};

export default EmployeePage;
